import type { RouteRecordRaw } from 'vue-router'
import PropertyTypesPage from './PropertyTypesPage.vue'

export const propertyTypesRoutes: RouteRecordRaw[] = [
  {
    path: '/masters/property-LTypes',
    name: 'masters.propertyTypes',
    component: PropertyTypesPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
]
